export const THREAD_READING_ORDER_STORAGE_KEY = "qwibThreadReadingOrder";

export const THREAD_READING_ORDER = {
  oldestFirst: "oldest-first",
  newestFirst: "newest-first",
} as const;

export type ThreadReadingOrder = (typeof THREAD_READING_ORDER)[keyof typeof THREAD_READING_ORDER];

export const isThreadReadingOrder = (value: string): value is ThreadReadingOrder =>
  value === THREAD_READING_ORDER.oldestFirst || value === THREAD_READING_ORDER.newestFirst;
